import { render, staticRenderFns } from "./NewProjectFlowLandingText.vue?vue&type=template&id=583ed2ca&scoped=true&"
import script from "./NewProjectFlowLandingText.vue?vue&type=script&lang=js&"
export * from "./NewProjectFlowLandingText.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectFlowLandingText.vue?vue&type=style&index=0&id=583ed2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583ed2ca",
  null
  
)

export default component.exports